"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION = void 0;
const PAGINATION = exports.PAGINATION = 'pagination';
